import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.js';
import { avisarNovaVersao, registrarAtualizacao } from './lib/atualizacao.js';
// Fontes auto-hospedadas: o app precisa renderizar igual sem rede, no haras.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource-variable/source-serif-4/wght.css';
import './styles.css';

/*
  Atualizacao nunca e automatica no meio de uma coleta: trocar a versao do app
  com a ficha aberta e a forma mais rapida de perder dado. O usuario decide, e
  so quando nao ha nada pendente (ver lib/atualizacao.ts).
*/
registrarAtualizacao(registerSW({ onNeedRefresh: avisarNovaVersao }));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
